import React, { useEffect, useState } from "react";
import { PRODUCTS_API } from "../../constants/api";
import { kTimestamp } from "../../constants/strings";
import { limit, orderBy, query, where } from "firebase/firestore";
import { useProducts } from "../../hooks/useProducts";
import CollapseTable from "../../components/tables/CollapseTable";
import { SearchBar } from "../../components/input/search/SearchBar";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";

export const ProductsRegister = () => {
  const { productsTableColumns, productsTableData } = useProducts();
  const [search, setSearch] = useState(null);
  const [filter, setFilter] = useState(orderBy(kTimestamp, "desc"));
  // SET CUSTOM QUERY
  const productRef = query(PRODUCTS_API, filter, getDefaultLimit());
  // custom pagination hook
  const {
    fetchMore,
    paginatedList: products,
    setList,
    getList: getProducts,
    loading,
  } = usePagination(productRef);

  useEffect(() => {
    getProducts();
  }, [filter]);

  useEffect(() => {
    // search empty string as well
    if (search)
      return setFilter(
        where("keywords", "array-contains", search.trim().toLowerCase())
      );
    // default product items
    setFilter(orderBy(kTimestamp, "desc"));
  }, [search]);

  return (
    <div>
      <br />
      <SearchBar setSearch={setSearch} />
      <CollapseTable
        loading={loading}
        columns={productsTableColumns}
        rows={productsTableData(products)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
